/**
 * Freemail-Adressen bekommen keinen kostenlosen Testzeitraum — Produktkarte
 * (Knopf „2 Wochen Testzeitraum starten") und Portal-Hinweis 4 („Mehr Credits
 * im Free-Trial") lesen dieselbe Liste, damit der Hinweis nie auf einen Plan
 * zeigt, der keinen Trial-Knopf hat.
 */
export const FREEMAIL_DOMAINS = [
  '@gmail.com',
  '@googlemail.com',
  '@outlook.com',
  '@hotmail.com',
  '@live.com',
  '@yahoo.com',
  '@icloud.com',
  '@me.com',
  '@mac.com',
  '@proton.me',
  '@protonmail.com',
  '@gmx.de',
  '@gmx.net',
  '@gmx.com',
  '@web.de',
  '@yandex.com',
  '@yandex.ru',
  '@zoho.com',
  '@tutanota.com',
  '@tutanota.de',
];

export function isFreemailAddress(email: string | null | undefined): boolean {
  return !!email && FREEMAIL_DOMAINS.some((domain) => email.includes(domain));
}

/** Plan-ID des Free-Plans (product.service.ts). */
export const FREE_PLAN_ID = 'ed738dc0-483a-4d1e-a779-b7fb29f8c5b0';
